import { createSyncAction, jwtDecode } from '@bimser/core';
import { put, takeEvery } from 'redux-saga/effects';
import { ServiceList } from '../../../services/serviceList';
import * as ActionTypes from '../actions/actionTypes';
import { IControlTokenResponse } from '../entities/ControlTokenResponse';
import { setDelegationInformationAction } from '../../../action/setDelegationInformationAction';
import { controlTokenAction } from '../actions';
import MainUtils from '../../../utilities/MainUtils';
import { removeAuth } from '../../../utilities/removeAuth';
import { Mobile } from '../../../utilities/MobileView';

export default function* watchControlTokenTransaction() {
	yield takeEvery(ActionTypes.CONTROL_TOKEN_TRANSACTION, controlTokenTransaction);
}

export function* controlTokenTransaction(sagaAction?: any) {
	let status: boolean = false;
	try {
		const response = yield ServiceList.login.Login.ControlToken.handleError(
			MainUtils.customErrorHandle
		).call(true);
		const responseData: IControlTokenResponse = response.data;
		const headerLanguage = response.headers['bimser-language'];
		localStorage.setItem('locale', headerLanguage);
		if (responseData.isValid) {
			status = true;
			const decodedToken = jwtDecode(responseData.token);

			yield put(controlTokenAction(responseData));
			yield put(setDelegationInformationAction(decodedToken.AuthenticationType == 2));
			yield put(createSyncAction(ActionTypes.CHANGE_TOKEN_CHECK_STATUS, true));
			response?.data?.isExpired && removeAuth(response.data.token);
		}
		Mobile.MobileView.authorizationCheckPoint({
			type: 'ControlToken',
			isValid: status,
			token: null,
			isExpired: response?.data?.isExpired
		});
	} finally {
		return status;
	}
}
